export class ApiResponse<T> {
    public response: T;
    public result: string;

    constructor(httpResponse?: ApiResponse<T>) {
        this.response = httpResponse && httpResponse.response || null;
        this.result = httpResponse && httpResponse.result || '';
    }
}
